import { useState, useEffect, Fragment, CSSProperties } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";
import { ValidationError } from "../../../common/ExceptionError";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import CustomRadioBtn from "../../base/CustomRadioBtn";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import { CustomCircleCheckBox, CustomSquareCheckBox } from "../../base/CustomCheckBox";
import CustomText from "components/base/CustomText";
import { checkFormatAllow } from "common/util";

interface InstanceTypeAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
};

InstanceTypeAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function InstanceTypeAdd(props:InstanceTypeAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);
    
    const [vmTypeName, setVmTypeName] = useState("");
    const [vmTypePubType, setVmTypePubType] = useState("PUB");
    const [vmTypeCpu, setVmTypeCpu] = useState("0");
    const [vmTypeMem, setVmTypeMem] = useState("0");
    const [vmTypeRootDisk, setVmTypeRootDisk] = useState("0");
    const [vmTypeTempDisk, setVmTypeTempDisk] = useState("0");
    const [vmTypeSwapDisk, setVmTypeSwapDisk] = useState("0");
    const [gpuYn, setGpuYn] = useState(false);
    const [hostClusterId, setHostClusterId] = useState("NRM");
    
    const [targetId, setTargetId] = useState("");
    
    const [hostClusterList, setHostClusterList] = useState<DropdownType[]>([ {value: 'NRM', label: t('NORMAL_NO_SELECT_TEXT')} ]);
    const [projectList, setProjectList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);

    const [vmTypeNameWarnYn, setVmTypeNameWarnYn] = useState(false);
    const [vmTypeCpuWarnYn, setVmTypeCpuWarnYn] = useState(false);
    const [vmTypeMemWarnYn, setVmTypeMemWarnYn] = useState(false);
    const [vmTypeRootDiskWarnYn, setVmTypeRootDiskWarnYn] = useState(false);



    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                const successYn = checkInstanceTypeData();
                if(successYn) {
                    setExecuteAddYn(true);
                } else {
                    executeResult({successYn: false}, false, '');;
                }
            }
            
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(stepIndex === 0) {
            loadHostClusterList();
        }
    }, [stepIndex])

    useEffect(() => {
        if(vmTypePubType === "PRJ") {
            loadProjectList()
        }
    }, [vmTypePubType])

    useEffect(() => {
        if(executeAddYn) {
            executeAddVmType();
        }
    }, [executeAddYn]);

    function checkInstanceTypeData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        
        setVmTypeNameWarnYn(false);
        setVmTypeCpuWarnYn(false);
        setVmTypeMemWarnYn(false);
        setVmTypeRootDiskWarnYn(false);
        
        let message = "";
        let error = false;
        if(!vmTypeName) {
            message = t("MESSAGE_INSTANCE_TYPE_INFO_ENTER_ERROR_MESSAGE")
            setVmTypeNameWarnYn(true);    
            error = true;
        }
        if(checkFormatAllow(vmTypeCpu, ['number']) == false || Number(vmTypeCpu) <= 0){
            message = t("MESSAGE_INSTANCE_TYPE_INFO_ENTER_ERROR_MESSAGE")
            setVmTypeCpuWarnYn(true);    
            error = true;
        }
        
        if(checkFormatAllow(vmTypeMem, ['number']) == false || Number(vmTypeMem) <= 0){
            message = t("MESSAGE_INSTANCE_TYPE_INFO_ENTER_ERROR_MESSAGE")
            setVmTypeMemWarnYn(true);    
            error = true;
        }

        if(checkFormatAllow(vmTypeRootDisk, ['number']) == false || Number(vmTypeRootDisk) <= 0){
            message = t("MESSAGE_INSTANCE_TYPE_INFO_ENTER_ERROR_MESSAGE")
            setVmTypeRootDiskWarnYn(true);    
            error = true;
        }

        if(error === true) {
            executeResult({}, false, message);
        }
        
        return !error;
    }

    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }
    
    function loadProjectList() {
        requests.get(PLATFORM_URL.PROJECT)
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setProjectList(response.data.items.map((data, index) => {
                    return { value: data.project_id, label: data.project_name };
                }));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }
    function loadHostClusterList() {
        requests.get(PLATFORM_URL.HOST_CLUSTER, {size: 9999})
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                const hostClusterData = response.data.items.map((data) => {
                    return { value: data.host_cluster_type_code + '-' + data.host_cluster_id, label: data.host_cluster_name + ' ( AZ: ' + data.availability_zone_name + ' )' }
                })
                hostClusterData.unshift({value: 'NRM', label: t('NORMAL_NO_SELECT_TEXT')});
                setHostClusterList(hostClusterData);
            }
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }
    function executeAddVmType() {
        const addPackageData = {
            vm_type: {
                vm_type_name: vmTypeName,
                share_type_code: vmTypePubType,
                host_cluster_type_code: hostClusterId.indexOf('-') >= 0 ? hostClusterId.slice(0, hostClusterId.indexOf('-')) : hostClusterId,
                root_disk_capacity_gb: Number(vmTypeRootDisk),
                swap_disk_capacity_mb: Number(vmTypeSwapDisk),
                ephemeral_disk_capacity_gb: Number(vmTypeTempDisk),
                vcpu_count: Number(vmTypeCpu),
                memory_capacity_mb: Number(vmTypeMem),
                gpu_available_yn: gpuYn,
                
            }
        };
        if(vmTypePubType === "PRJ") {
            addPackageData["project"] = {
                project_id: targetId
            }
        }

        requests.post(PLATFORM_URL.INSTANCE_TYPE, addPackageData)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_INSTANCE_TYPE_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
            
        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_INSTANCE_TYPE_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }


    function selectButton(id, type){
        setVmTypePubType(type);
    }

    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("VM_TYPE_CREATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("INSTANCE_TYPE_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={2} 
                                width={570} height={36} 
                                value={vmTypeName} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setVmTypeName} 
                                warnYn={vmTypeNameWarnYn} 
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("INSTANCE_CPU_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={3} 
                                width={110} height={36} 
                                value={vmTypeCpu} 
                                type={"number"} 
                                activeYn={true} 
                                inputCb={setVmTypeCpu} 
                                warnYn={vmTypeCpuWarnYn} 
                            />
                            <Text style={style.diskUsageText}>
                                cores
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("INSTANCE_MEMORY_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={4} 
                                width={110} height={36} 
                                value={vmTypeMem} 
                                type={"number"} 
                                activeYn={true} 
                                inputCb={setVmTypeMem} 
                                warnYn={vmTypeMemWarnYn} 
                            />
                            <Text style={style.diskUsageText}>
                                MB
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("INSTANCE_ROOT_DISK_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={5} 
                                width={110} height={36} 
                                value={vmTypeRootDisk} 
                                type={"number"} 
                                activeYn={true} 
                                inputCb={setVmTypeRootDisk} 
                                warnYn={vmTypeRootDiskWarnYn} 
                            />
                            <Text style={style.diskUsageText}>
                                GB
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("INSTANCE_TEMP_DISK_TEXT")} fontStyle={style.columnText} asterisk={false}/>
                            <CustomTextInput 
                                key={6} 
                                width={110} height={36} 
                                value={vmTypeTempDisk} 
                                type={"number"} 
                                activeYn={true} 
                                inputCb={setVmTypeTempDisk} 
                                warnYn={false} 
                            />
                            <Text style={style.diskUsageText}>
                                GB
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("INSTANCE_SWAP_DISK_TEXT")} fontStyle={style.columnText} asterisk={false}/>
                            <CustomTextInput 
                                key={7} 
                                width={110} height={36} 
                                value={vmTypeSwapDisk} 
                                type={"number"} 
                                activeYn={true} 
                                inputCb={setVmTypeSwapDisk} 
                                warnYn={false} 
                            />
                            <Text style={style.diskUsageText}>
                                MB
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("INSTANCE_GPU_TEXT")} fontStyle={style.columnText} asterisk={false}/>
                            <CustomSquareCheckBox 
                                id={"GpuYn"}
                                key={33} 
                                checked={gpuYn}
                                label={t("USE_TEXT")}
                                setCheckBoxStatus={(e) => {setGpuYn(!gpuYn)}}
                            />
                        </View>
                        <View style={style.rowDivContainer}></View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("SHARE_CATEGORY_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomRadioBtn 
                                id={"InstanceShareType"} 
                                type={"PUB"} 
                                size={18} 
                                checked={vmTypePubType === "PUB" ? true: false} 
                                selectCb={selectButton} 
                                label={"공용(Pubilc)"}
                                labelStyle={labelStyle}
                            />
                            <View style={{width: 44}}/>
                            <CustomRadioBtn 
                                id={"InstanceShareType"} 
                                type={"PRJ"} 
                                size={19} 
                                checked={vmTypePubType === "PRJ" ? true: false} 
                                selectCb={selectButton} 
                                label={"개인(프로젝트)"}
                                labelStyle={labelStyle}
                            />
                        </View>
                        {
                            vmTypePubType !== "PUB" ?
                            <View style={style.rowContainer}>
                                <CustomText text={t("PROJECT_INFO_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomDropDown 
                                    key={10} 
                                    width={300} height={36} 
                                    items={projectList}
                                    setValue={setTargetId} 
                                    disable={false}
                                    defaultvalue={{label:"", value:""}}
                                />
                            </View>
                            : null
                        }
                        <View style={style.rowDivContainer}></View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("INSTANCE_TARGET_HOST_CLUSTER_TEXT")} fontStyle={style.columnText} asterisk={false}/>
                            <CustomDropDown 
                                key={25} 
                                width={400} height={36} 
                                items={hostClusterList}
                                setValue={setHostClusterId} 
                                disable={false}
                                defaultvalue={{value: 'NRM', label: t('NORMAL_NO_SELECT_TEXT')}}
                            />
                            
                        </View>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("DESCRIBE_INSTANCE_TYPE_CLUSTER_TYPE_SELECT")}
                        </Text>
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    diskUsageText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    rowInfoText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    rowStaticText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    dateText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    }
});

const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}